// extracted by mini-css-extract-plugin
export default {"minimalSafetyRowContainer":"styles_minimalSafetyRowContainer__A674j","iconClass":"styles_iconClass__gnOCa","safetyEventText":"styles_safetyEventText__hIShx"};